import {Promotion} from "../../classes/promotion"
import {SimpleProduct} from "../../classes/simple_product"
import {Combo} from "../../classes/combo"
import {BoolIntRes} from "../../classes/bool_int_res"
import {TipoBeneficio, MecanicaPromocion, TipoProductoParticipante} from "../../classes/enums"
import formatHelper from "../mixins/formatHelper";
export default {
   mixins: [formatHelper],
   methods: {
      /**
       * 
       * @param {Promotion[]} promotions 
       * @param {SimpleProduct[]} productos 
       */
      filterPromotionsForProducts(promotions, productos){
         let filtradas = [];
         this.mlog("iniciando...")
         promotions.forEach(item => {
            item.debug()
            if(item.quantity < 1 || item.available < 1){
               this.mlog("No disponibles")
               return;
            }

            let cantidadAplicable = 0;
            if(item.mecanicaPromocion() === MecanicaPromocion.Cantidad){
               this.mlog("es mecanica cantidad")
               let aplica = this.aplicaParaMecanica(item, productos);
               cantidadAplicable = aplica.intVal;
               this.mlog("aplica mecanica => " + aplica.boolVal)
               if(aplica.boolVal){
                  this.mlog("Cantidad aplicable => " + cantidadAplicable)
                  let realAplicable = Math.min(cantidadAplicable, item.quantity);
                  this.mlog("aplica con " + cantidadAplicable);
                  this.mlog("tiene disponibles " + item.quantity);
                  this.mlog("cantidad real aplicable " + realAplicable);

                  item.applicable_quantity = realAplicable;
                  /*item.applicable = true;
                  item.applicable_quantity = realAplicable;
                  filtradas.push(item);*/
               }
            }
            else if(item.mecanicaPromocion() == MecanicaPromocion.Paquete){
               let benef = this.aplicaBeneficio(item, productos, cantidadAplicable);
               let cantidadBeneficios = benef.intVal;
               if (!benef.boolVal){
                  // la promocion no aplica por falta de beneficios
                  return;
               }

               // aplicar la logica de varias opciones
               if(item.multiCombo()){
                  let minAplicableCombo = 0;
                  let aplicables = 0;
                  let co = 1;

                  item.combos.forEach(combo => {
                     let app = this.aplicaParaCombo(combo.combo_1, productos);
                     let cantidad = app.intVal;
                     if(app.boolVal){
                        aplicables += 1;
                     }

                     let s = "Combo " + co;
                     if (app){
                        s += " aplica hasta con " + cantidad;
                     }
                     else {
                        s += " no aplica con " + cantidad; 
                     }

                     this.mlog(s)


                     let cantidadAplicableCombo = 0;
                     if (item.tipoBeneficio() == TipoBeneficio.Descuento){
                        this.mlog("Beneficio tipo descuento, Cantidad aplicable sin topar: " + cantidad);
                        cantidadAplicableCombo = cantidad;
                     }
                     else{
                        cantidadAplicableCombo = Math.min(cantidad, cantidadBeneficios);
                        this.mlog("Cantidad aplicable topada por beneficios: " + cantidadAplicableCombo);
                     }

                     combo.applicable = app;
                     combo.applicable_quantity = cantidadAplicableCombo;
                     co += 1;

                     if (app){
                        if (minAplicableCombo == 0){
                           minAplicableCombo = cantidadAplicableCombo;
                        }
                        else{
                           minAplicableCombo = Math.min(minAplicableCombo, cantidadAplicableCombo);
                        }
                     }
                  });

                  if(aplicables < 1){
                     // la promocion en general no aplica porque no hay al menos un combo aplicable
                     return;
                  }

                  // se establece que la cantidad maxima de veces que se puede aplicar 
                  // es igual a la menor cantidad aplicable de los combos validos
                  let realAplicable = Math.min(minAplicableCombo, item.Disponibles);
                  this.mlog("promo aplica con " + minAplicableCombo);
                  this.mlog("tiene disponibles " + item.Disponibles);
                  this.mlog("cantidad real aplicable " + realAplicable);

                  item.applicable_quantity = realAplicable;
               }
               else {
                  let aplica = this.aplicaParaComboUnico(item, productos);
                  cantidadAplicable = aplica.intVal;
                  if (aplica.boolVal && cantidadAplicable > 0){
                     let realAplicable = Math.min(cantidadAplicable, item.quantity);
                     this.mlog("promo aplica con " + cantidadAplicable);
                     this.mlog("tiene disponibles " + item.quantity);
                     this.mlog("cantidad real aplicable " + realAplicable);

                     item.applicable_quantity = realAplicable;
                  }
               }
            }

            if(item.applicable_quantity > 0){
               item.applicable = true;
               filtradas.push(item);
            }
         });

         return filtradas;
      },
      
      /**
       * 
       * @param {Promotion} promo 
       * @param {SimpleProduct[]} productos 
       * @param {*} cantidadAplicable 
       */
      aplicaParaComboUnico(promo, productos){
         let cantidadAplicable = 0;
         let aplicaBeneficio = false;
         let aplicaMecanica_1 = false;
         let aplicaMecanica_2 = false;
         let cantidadMecanica_1 = 0;
         let cantidadMecanica_2 = 0;
         let cantidadMecanica = 0;
         let cantidadBeneficio = 0;

         aplicaMecanica_1 = this.aplicaParaCombo(promo.combos[0].combo_1, productos, cantidadMecanica_1);
         aplicaMecanica_2 = this.aplicaParaCombo(promo.combos[0].combo_2, productos, cantidadMecanica_2);

         cantidadMecanica = Math.min(cantidadMecanica_1, cantidadMecanica_2);

         if (promo.tipoBeneficio() == TipoBeneficio.Descuento){
            cantidadAplicable = cantidadMecanica;
            return BoolIntRes.createForTrue(cantidadAplicable)
         }

         aplicaBeneficio = this.aplicaBeneficio(promo, productos, cantidadBeneficio);
         cantidadBeneficio = aplicaBeneficio.intVal;
         if(aplicaMecanica_1 && aplicaMecanica_2 && aplicaBeneficio.boolVal){
            cantidadAplicable = Math.min(cantidadMecanica, cantidadBeneficio);

            if (cantidadAplicable > 0){
               return BoolIntRes.createForTrue(cantidadAplicable)
            }
         }

         return BoolIntRes.createForNone()
      },

      /**
       * 
       * @param {Combo} combo 
       * @param {*} productos 
       */
      aplicaParaCombo(combo, productos){
         let cantidadMecanica = 0;
         let totalDisponible = 0;

         if (combo.tipoProductoParticipante() == TipoProductoParticipante.Producto){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.Producto, combo.product_id, 0);
         }
         else if (combo.tipoProductoParticipante() == TipoProductoParticipante.Linea){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.Linea, combo.line_id, 0);
         }
         else if (combo.tipoProductoParticipante() == TipoProductoParticipante.LineaPresentacion){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.LineaPresentacion, combo.line_id, combo.presentation_id);
         }
         else if (promo.tipoProductoParticipante() == TipoProductoParticipante.TODOS) {
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.TODOS, 0, 0);
         }

         if (totalDisponible < 1){
            return BoolIntRes.createForNone()
         }

         cantidadMecanica = Math.floor( totalDisponible / combo.quantity);

         if (cantidadMecanica > 0){
            return BoolIntRes.createForTrue(cantidadMecanica)
         }

         return BoolIntRes.createForNone()
      },

      /**
       * 
       * @param {Promotion} promo 
       * @param {SimpleProduct[]} productos
       */
      aplicaParaMecanica(promo, productos){
         let aplicaMecanica = false;
         let aplicaBeneficio = false;

         let cantidadAplicable = 0;
         let consumo = promo.mechanic.quantity;
         let totalDisponible = 0;
         let cantidadMecanica = 0;
         let cantidadBeneficio = 0;

         if (promo.tipoProductoParticipante() === TipoProductoParticipante.Producto){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.Producto, promo.mechanic.product_id, 0);
         }
         else if (promo.tipoProductoParticipante() == TipoProductoParticipante.Linea){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.Linea, promo.mechanic.line_id, 0);
         }
         else if (promo.tipoProductoParticipante() == TipoProductoParticipante.LineaPresentacion){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.LineaPresentacion, promo.mechanic.line_id, promo.mechanic.presentation_id);
         }
         else if (promo.tipoProductoParticipante() == TipoProductoParticipante.TODOS) {
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.TODOS, 0, 0);
         }
         this.mlog("total disponibles => " + totalDisponible)

         if(totalDisponible < 1){
            return BoolIntRes.createForNone()
         }

         cantidadMecanica = Math.floor( totalDisponible / consumo);
         this.mlog("cantidad mecanica => " + cantidadMecanica)

         if (cantidadMecanica < 1){
            return BoolIntRes.createForNone()
         }
         else {
            aplicaMecanica = true;
         }

         if(promo.tipoBeneficio() == TipoBeneficio.Descuento){
            cantidadAplicable = cantidadMecanica;
            this.mlog("cantidad aplicable descuento => " + cantidadAplicable)
            return BoolIntRes.createForTrue(cantidadAplicable)
         }

         aplicaBeneficio = this.aplicaBeneficio(promo, productos, 0);
         cantidadBeneficio = aplicaBeneficio.intVal;
         if(aplicaMecanica && aplicaBeneficio.boolVal){
            cantidadAplicable = Math.min(cantidadMecanica, cantidadBeneficio);
            this.mlog("cantidad aplicable beneficio => " + cantidadAplicable)

            if(cantidadAplicable > 0){
               return BoolIntRes.createForTrue(cantidadAplicable)
            }
         }

         return BoolIntRes.createForNone()
      },

      /**
       * 
       * @param {SimpleProduct[]} productos 
       * @param {*} tipo 
       * @param {*} id1 
       * @param {*} id2 
       */
      totalDisponibleParaTipoProducto(productos, tipo, id1, id2){
         let resultados = [];
         if (tipo == TipoProductoParticipante.Producto){
            resultados = productos.filter(obj => obj.id === id1);
         }
         else if(tipo == TipoProductoParticipante.Linea){;
            resultados = productos.filter(obj => obj.line_id === id1);
         }
         else if (tipo == TipoProductoParticipante.LineaPresentacion){
            resultados = productos.filter(obj => obj.line_id === id1 && obj.presentation_id === id2);
         }
         else if (tipo == TipoProductoParticipante.TODOS){
            resultados = productos.filter(obj => obj.stock > 0);
         }
         let total = 0;
         resultados.forEach(obj => {total += obj.stock})
         return total;
      },

      /**
       * 
       * @param {Promotion} promo 
       * @param {SimpleProduct[]} productos 
       * @param {*} cantidadAplicable 
       */
      aplicaBeneficio(promo, productos, cantidadAplicableInicial){
         let cantidadAplicable = 0;
         let totalDisponible = 0;

         if (promo.tipoBeneficio() == TipoBeneficio.Descuento){
            return BoolIntRes.createForTrue(cantidadAplicableInicial)
         }

         if(promo.tipoProductoBeneficio() == TipoProductoParticipante.Producto){
            totalDisponible = this.totalDisponibleParaTipoProducto(productos, TipoProductoParticipante.Producto, promo.benefit.product_id, 0);
         }
         else if( promo.tipoProductoBeneficio() == TipoProductoParticipante.Linea){
            totalDisponible = this.totalDisponibleIndividualParaLineaPresentacion(productos, TipoProductoParticipante.Linea, promo.benefit.line_id, 0);
         }
         else if (promo.tipoProductoBeneficio() == TipoProductoParticipante.LineaPresentacion){
            totalDisponible = this.totalDisponibleIndividualParaLineaPresentacion(productos, TipoProductoParticipante.LineaPresentacion, promo.benefit.line_id, promo.benefit.presentation_id);
         }

         this.mlog("total disponible beneficio => "+ totalDisponible);

         if(totalDisponible < 1){
            return BoolIntRes.createForNone()
         }

         cantidadAplicable = Math.floor (totalDisponible / promo.benefit.quantity);
         this.mlog("aplica beneficio para id " + promo.id + ", => " + cantidadAplicable)

         if(cantidadAplicable > 0){
            return BoolIntRes.createForTrue(cantidadAplicable)
         }
         else {
            return BoolIntRes.createForNone()
         }
      },

      /**
       * 
       * @param {SimpleProduct[]} productos 
       * @param {*} tipo 
       * @param {*} id1 
       * @param {*} id2 
       */
      totalDisponibleIndividualParaLineaPresentacion(productos, tipo, id1, id2){
         let resultados = [];
         if (tipo == TipoProductoParticipante.Linea){
            resultados = productos.filter(obj => obj.line_id == id1);
         }
         else if (tipo == TipoProductoParticipante.LineaPresentacion){
            resultados = productos.filter(obj => (obj.line_id == id1 && obj.presentation_id == id2));
         }

         let max = 0;
         resultados.forEach(f => {
            max = Math.max(f.stock, max);
         });
         return max;
      },

      /**
       * 
       * @param {Promotion[]} promociones 
       */
      idsProductosEnPromociones(promociones){
         let ids = [];
         promociones.foreach(item => {
            const participantes = item.mechanic.productos_Participantes();
            participantes.forEach(prod => {
               if(!ids.find(prod.ID)){
                  ids.push[prod.ID]
               }
            });
         });
         return ids;
      },

      /**
       * 
       * @param {Promotion} p 
       */
      descripcionGeneralPromocion(p){
         let s = "";

         if(p.mecanicaPromocion() == MecanicaPromocion.Cantidad){
            s = "En la compra de ";
            s += p.mechanic.quantity;
            s += " ";
            if (p.tipoProductoParticipante() == TipoProductoParticipante.Producto){
               s += p.mechanic.product_name;
            }
            else if(p.tipoProductoParticipante() == TipoProductoParticipante.Linea){
               s += " producto(s) de la línea " + p.mechanic.line_name;
            }
            else if (p.tipoProductoParticipante() == TipoProductoParticipante.LineaPresentacion){
               s += " producto(s) de la línea " + p.mechanic.line_name + ", presentación " + p.mechanic.presentation_name;
            }
            else if (p.tipoProductoParticipante() == TipoProductoParticipante.TODOS){
               s += " producto(s) de cualquier tipo"
            }
            s += ", ";
         }
         else if(p.mecanicaPromocion() == MecanicaPromocion.Paquete) {
            s = "Al comprar\n\n";
            if(p.multiCombo()){
               let first = true;
               p.combos.forEach(combo => {
                  if(!first){
                     s += "\n\nÓ\n\n";
                  }
                  first = false;
                  s += "- " + combo.descripcion_1();
               })
            }
            else{
               s += "- ";
               s += p.combos[0].descripcion_1();
               s += "\n\nY\n\n";
               s += "- ";
               s += p.combos[0].descripcion_2();
            }

            s += "\n\n";
         }

         if(p.tipoBeneficio() == TipoBeneficio.Descuento){
            s += " se ofrece un descuento de " + this.explicitMoneyFormat(p.benefit.price);
         }
         else if(p.tipoBeneficio() == TipoBeneficio.Souvenir){
            s += "se obsequia " + p.benefit.quantity;
            s += " ";
            if(p.tipoProductoBeneficio() == TipoProductoParticipante.Producto)
            {
               s += p.benefit.product_name;
            }
            else if (p.tipoProductoBeneficio() == TipoProductoParticipante.Linea)
            {
               s += " producto(s) de la línea " + p.benefit.line_name;
            }
            else if (p.tipoProductoBeneficio() == TipoProductoParticipante.LineaPresentacion)
            {
               s += " producto(s) de la línea " + p.benefit.line_name + ", presentación " + p.benefit.presentation_name;
            }
         }
         return s;
      },

      /**
       * 
       * @param {Promotion} promotion 
       * @param {SimpleProduct[]} products 
       */
      getSelectionableProductsForPromo(promotion, products){
         let prods = []
         if(promotion.tipoProductoParticipante() === TipoProductoParticipante.Producto){
            prods = products.filter(f => f.id === promotion.mechanic.product_id);
         }
         else if(promotion.tipoProductoParticipante() === TipoProductoParticipante.Linea){
            prods = products.filter(f => f.line_id === promotion.mechanic.line_id);
         }
         else if(promotion.tipoProductoParticipante() === TipoProductoParticipante.LineaPresentacion){
            prods = products.filter(f => f.line_id === promotion.mechanic.line_id && f.presentation_id === promotion.mechanic.presentation_id);
         }
         else if(promotion.tipoProductoParticipante() === TipoProductoParticipante.TODOS){
            prods = products.filter(f => f.stock > 0);
         }
         return prods;
      },

      /**
       * 
       * @param {Promotion} promotion 
       * @param {SimpleProduct[]} products 
       */
      getSelectionableGiftsForPromo(promotion, products){
         let gifts = []
         if(promotion.tipoProductoBeneficio() === TipoProductoParticipante.Producto){
            gifts = products.filter(f => f.id === promotion.benefit.product_id);
         }
         else if(promotion.tipoProductoBeneficio() === TipoProductoParticipante.Linea){
            gifts = products.filter(f => f.line_id === promotion.benefit.line_id);
         }
         else if(promotion.tipoProductoBeneficio() === TipoProductoParticipante.LineaPresentacion){
            gifts = products.filter(f => f.line_id === promotion.benefit.line_id && f.presentation_id === promotion.benefit.presentation_id);
         }
         return gifts;
      },

      mlog(data){
         console.log(data);
      }
   }
}